import { initAxios } from '../../../utils/axiosHelper';

export interface DatabaseEntityName {
  databaseEntityId: string;
  /** The record page lives at `/supplier/:entityId`. */
  entityId: string;
  name: string | null;
}

/**
 * Names and entity ids for up to 100 of a database's Database Entities, or null
 * when the lookup fails. Ids no longer in the database are left out.
 */
export const lookupDatabaseEntities = async (
  databaseId: string,
  databaseEntityIds: string[],
  selectedTeamId: string,
): Promise<DatabaseEntityName[] | null> => {
  try {
    const instance = await initAxios();
    if (!instance || !selectedTeamId) return null;
    const resp = await instance.post(
      `/bite-db/database/${databaseId}/entities/lookup`,
      { database_entity_ids: databaseEntityIds },
      { headers: { 'x-selected-team-id': selectedTeamId } },
    );
    const rows: any[] = Array.isArray(resp.data?.data) ? resp.data.data : [];
    return rows.map((row) => ({
      databaseEntityId: String(row.database_entity_id),
      entityId: String(row.entity_id),
      name: row.name ?? null,
    }));
  } catch {
    return null;
  }
};
